export default __webpack_public_path__ + "static/cloud_migrate_cta-bdb47bfede67ad37c0fd9e00edced1d5.webp";